import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

function App() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_oguizul",
        "template_fri2n7s",
        form.current,
        process.env.REACT_APP_API_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Messaggio inviato con successo!");
          form.current.reset();
        },
        (error) => {
          console.log(error.text);
          alert("Impossibile inviare il messaggio, riprovare.");
        }
      );
  };

  return (
    <form ref={form} method="POST" onSubmit={sendEmail}>
      <div className="row">
        <div className="col-md-6">
          <div className="md-form mb-0">
            <input
              type="text"
              id="form41"
              className="form-control"
              name="name"
              required
            />
            <label htmlFor="form41" className="">
              Il tuo nome
            </label>
          </div>
        </div>

        <div className="col-md-6">
          <div className="md-form mb-0">
            <input
              type="email"
              id="form52"
              className="form-control"
              name="email"
              required
            />
            <label htmlFor="form52" className="">
              La tua email
            </label>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="md-form mb-0">
            <input
              type="text"
              id="form51"
              className="form-control"
              name="title"
              required
            />
            <label htmlFor="form51" className="">
              Titolo della richiesta
            </label>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="md-form mb-0">
            <textarea
              type="text"
              id="form76"
              className="md-textarea form-control"
              rows="3"
              name="message"
              required
            ></textarea>
            <label htmlFor="form76">Il tuo messaggio</label>
          </div>
        </div>
      </div>
      <div className="text-center text-md-left mb-5 mt-4">
        <input
          type="submit"
          className="btn btn-rounded btn-white font-weight-bold"
          value="Invia"
        />
      </div>
    </form>
  );
}

export default App;
